/* eslint-disable camelcase */
export const kpis = {
  budget: 'Budget dépensé (%)',
  mediaBudget: 'Budget média',
  cpm: 'CPM',
  ctr: 'CTR',
  clicks: 'Clics',
  cpc: 'CPC',
  cpa: 'CPA',
  kpi2: 'CPV',
  cr1_2: 'Taux de visite',
  cr2_4: 'Taux de conversion',
  ermesVisits: 'Visites Ermes',
  ermesCpv: 'CPV Ermes',
  reach: 'Audience',
  reachRepetition: 'Répetition',
  toSpendBudget: 'Budget à dépenser',
  volume1: 'Impressions',
  volume2: 'Visites',
  p25VideoCompletionVolume: 'Complétion vidéo 25%',
  p50VideoCompletionVolume: 'Complétion vidéo 50%',
  p75VideoCompletionVolume: 'Complétion vidéo 75%',
  p100VideoCompletionVolume: 'Complétion vidéo 100%',
  p25VideoCompletionPercent: 'Pourcentage de complétion vidéo 25%',
  p50VideoCompletionPercent: 'Pourcentage de complétion vidéo 50%',
  p75VideoCompletionPercent: 'Pourcentage de complétion vidéo 75%',
  p100VideoCompletionPercent: 'Pourcentage de complétion vidéo 100%',
  cpP25VideoCompletionVolume: 'Coût par complétion vidéo 25%',
  cpP50VideoCompletionVolume: 'Coût par complétion vidéo 50%',
  cpP75VideoCompletionVolume: 'Coût par complétion vidéo 75%',
  cpP100VideoCompletionVolume: 'Coût par complétion vidéo 100%',
  volumeSent: 'Envoyé',
  volumeDelivered: 'Délivré',
  volumeOpened: 'Ouvert',
  reactivityRate: 'Taux de réactivité',
  openRate: 'Taux d’ouverture',
  cpOpen: 'Coût par ouverture',
  couverture: 'Couverture',
  videoCompletion: 'Complétions Vidéo',
  videoCompletionPercent: '% Complétions Vidéo',
  costCompletionVideo: 'Coût/Complétions Vidéo',
  volume2Ermes: 'Visites Ermes',
  kpi2Ermes: 'CPV Ermes',
  'sms&Email': 'SMS/Mail',
  calls: 'Appels',
  receivedCalls: 'Reçus',
  answeredCalls: 'Décrochés',
  missedCalls: 'Manqués',
  totalCallsDuration: 'Durée totale',
  volumeClics: 'Clics',
  volumeConversions: 'Conversions'
};
export const granularities = {
  media: 'Médias',
  regie: 'Supports',
  io: 'Campagne',
  lineItem: 'Ensemble de publicité',
  ad: 'Publicité',
  channel: 'Canal',
  format: 'Format'
};
